import { OfferSelectOption } from '@recruitee/offers-ui';
import type { Placement, PlacementBase } from '@recruitee/placements-types';

export type RequiredPlacementProps = Pick<PlacementBase, 'ratingVisible'>;

export const isPlacementHidden = (placement: RequiredPlacementProps) =>
  placement.ratingVisible === false;

export const isAnyPlacementHidden = (placements: RequiredPlacementProps[]) =>
  placements.some(isPlacementHidden);

export function offerSelectOptionsFromPlacements(placements: Placement[]): OfferSelectOption[] {
  return <OfferSelectOption[]>placements?.map(placement => {
      const { offer, talentPool } = placement;
      return {
        id: (offer || talentPool)!.id,
        title: (offer || talentPool)!.title,
        kind: (offer || talentPool)!.kind,
        status: (offer || talentPool)!.status,
      };
    }) ?? [];
}
